import ImageEditor from "./ImageEditor";

export default ImageEditor;